import React from 'react';
import { Box } from '@mui/material';
import Skeleton from '@mui/material/Skeleton';

const MapSectionSkeleton = () => (
  <Box my={3}>
    <Skeleton variant="rounded" width="100%" height={400} />
    <Skeleton variant="text" width="300px" height={40} />
    <Skeleton variant="text" width="200px" height={20} />
    <Skeleton variant="text" width="100%" height={75} />
    <Skeleton variant="text" width="150px" height={50} />
  </Box>
);
export { MapSectionSkeleton };
